import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { ZipwhipSetting } from '../types'

export type FetchZipwhipSettingsForOptionsAction = FSA<undefined, ZipwhipSetting[], string>
type FetchZipwhipSettingsForOptions = (searchText?: string) => MrxThunk<FetchZipwhipSettingsForOptionsAction>
type QueryResponse = GraphQLResponse<'zipwhipSettingsForOptions', ZipwhipSetting[]>

const FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS = `
  query fetchZipwhipSettingsForOptions ($workspaceId: Int!, $limit: Int, $searchText: String) {
    zipwhipSettingsForOptions (workspaceId: $workspaceId, limit: $limit, searchText: $searchText) {
      id
      name
    }
  }
`

const fetchZipwhipSettingsForOptions: FetchZipwhipSettingsForOptions = (searchText) => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS,
      variables: { workspaceId, searchText }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { zipwhipSettingsForOptions } = data
    if (!zipwhipSettingsForOptions) {
      throw new Error("Can't get Zipwhip settings!")
    }

    dispatch({
      type: t.FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS,
      payload: zipwhipSettingsForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_ZIPWHIP_SETTINGS_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchZipwhipSettingsForOptions }
